import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {
    Router,
    RoutesRecognized
} from '@angular/router';
import {DxSelectBoxComponent} from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import {LoginService} from 'app/services/login.service';
import {CommonService} from 'app/services/common/common.service';
import {ConsultantService} from '../../services/consultant/consultant.service';
import {siteConfig} from '../../siteSettings';
import notify from "devextreme/ui/notify";
import {Location} from "@angular/common";
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UiActions } from '../../store/ui/ui.actions';
import { selectLeftNav, selectRightNav, selectSearchBoxVisible } from '../../store/ui/ui.selectors';
import { selectCurrentUser } from '../../store/auth/auth.selectors';
import { CommonActions } from '../../store/common/common.actions';

@Component({
    selector: 'pulse-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    providers: [ConsultantService],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PulseHeaderComponent implements OnInit, OnDestroy {

    @ViewChild(DxSelectBoxComponent) dxSelectBox: DxSelectBoxComponent;
    isLoggedIn = false;
    showLoadingBar = false;
    currentUser: any = {};
    leftNavigation: any = [];
    rightNavigation: any = [];
    datasource: any = [];
    searchBoxVisible: false;
    defaultAvatarUrl: string = '/assets/images/avatars/profile.jpg';
    selectBoxDataSource: any = {};
    searchedConsultantId: number = null;
    consultantSearched: boolean = false;
    nextPath: any = '';
    isAdmin = false;
    isLoginButtonVisible: boolean = true;
    siteConfig: any = siteConfig;
    showHeader: boolean = true;
    href = '';
    private unsubscribe$ = new Subject<void>();

    constructor(public router: Router,
                private location: Location,
                private commonService: CommonService,
                private consultantService: ConsultantService,
                private loginService: LoginService,
                private store: Store,
                private cdr: ChangeDetectorRef
    ) {
        this.href = window.location.href;
        // window.addEventListener("online", () => {debugger});
        window.addEventListener("offline", () => {
            notify("Connection problem", "error", 3000);
        });
        // debugger;
        this.showHeader = !(this.location.path().indexOf('/display/') > -1);

        this.loginService.isLoggedInObj.subscribe(value => {
            if (value) {
                this.currentUser = JSON.parse(localStorage.getItem('userData'));
                this.currentUser.fullName = this.currentUser.first_name;
                this.currentUser.fullName += this.currentUser.last_name ? ` ${this.currentUser.last_name}` : '';
                this.isLoggedIn = true;
                if (this.currentUser.roleNames) {
                    this.currentUser.displayRoleName = this.currentUser.roleNames.split(',')[0];
                }
                this.store.dispatch(CommonActions.loadMasterData());
                this.store.dispatch(CommonActions.loadBusinessEntities());
                this.store.dispatch(UiActions.loadNavigation({ userId: this.currentUser.id }));

            } else {
                this.isLoggedIn = false;
            }
            this.cdr.markForCheck();
        });

        this.store.select(selectCurrentUser).pipe(takeUntil(this.unsubscribe$)).subscribe(result => {
            if (!result) {
                return;
            }
            this.currentUser = { ...result };
            this.currentUser.fullName = this.currentUser.first_name;
            this.currentUser.fullName += this.currentUser.last_name ? ` ${this.currentUser.last_name}` : '';
            if (this.currentUser.roleNames) {
                this.currentUser.displayRoleName = this.currentUser.roleNames.split(',')[0];
            }

            if (this.currentUser && this.currentUser.roleNames && this.currentUser.roleNames.indexOf('Admin') > -1) {
                this.isAdmin = true;
            }
            this.cdr.markForCheck();
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    ngOnInit() {
        // Navigation from store
        this.store.select(selectLeftNav).pipe(takeUntil(this.unsubscribe$)).subscribe(leftNav => {
            this.leftNavigation = leftNav;
            this.cdr.markForCheck();
        });
        this.store.select(selectRightNav).pipe(takeUntil(this.unsubscribe$)).subscribe(rightNav => {
            this.rightNavigation = rightNav;
            this.cdr.markForCheck();
        });
        this.store.select(selectSearchBoxVisible).pipe(takeUntil(this.unsubscribe$)).subscribe(visible => {
            this.searchBoxVisible = visible as any;
            this.cdr.markForCheck();
        });
        if (this.isLoggedIn) {
            // this.commonService.getAllMasterData();
            // this.commonService.getAllBusinessEntities();
            this.selectBoxDataSource = new DataSource({
                store: new CustomStore({
                    key: 'ID',
                    load: (loadOptions) => {
                        const finalData = [];
                        if (!loadOptions.searchValue) {
                            return finalData;
                        }
                        return this.consultantService.searchConsultant(loadOptions.searchValue)
                            .toPromise()
                            .then(response => {
                                // Here, you can perform operations unsupported by the server
                                const result = response['data'];

                                for (let i = 0; i < result.length; i++) {
                                    const tmpArray = {
                                        ConsultantID: result[i]['consultant_id'],
                                        ConsultantFullName: result[i]['ConsultantFullName'],
                                        email: result[i]['email'],
                                        NamewithEmail: result[i]['ConsultantFullName'] + ' (' + result[i]['email'] + ')'
                                    };
                                    if (result[i]['saveStatus']) {
                                        tmpArray.NamewithEmail = result[i]['saveStatus'] + ' - ' + tmpArray.NamewithEmail;
                                    }
                                    finalData.push(tmpArray);
                                }
                                // this.datasource = finalData;
                                return finalData;
                            });
                    }
                })

            });
        }

        this.router.events
            .subscribe((e) => {
                if (e instanceof RoutesRecognized) {
                    this.isLoginButtonVisible = true;
                    this.nextPath = e.url;
                }
            });
        this.commonService._listners$.subscribe(event => {
            if (!(this.nextPath.indexOf('consultant/edit') > -1 && this.router.url.indexOf('consultant/edit') > -1)
                && event === 'clearSearch') {
                this.consultantSearched = false;
                this.dxSelectBox.instance.reset();
            }
        });



    }

    searchConsultant() {
        if (this.searchedConsultantId) {
            this.consultantSearched = true;
            this.router.navigate(['/consultant/edit/' + this.searchedConsultantId]);
            window.localStorage.setItem('selectedIndex', '8');

        }
    }


    logout() {
        this.loginService.logout();
        this.router.navigate(['login']);
        window.location.reload();
    }
}

export class HeaderComponent {
}
